import React, { useState, useEffect } from 'react';

import { SelectGroup } from '../../../components/SelectGroup';
import { Select } from '../../../components/Select';
import Accordion from '../../../components/Accordion';
import Alert from '../../../components/Alert';
import Button from '../../../components/Button';
import Icon from '../../../components/Icons';
import Pagination from '../../../components/Pagination';
import SearchContainer from '../../../components/SearchContainer';

import { useGlobal } from '../../../contexts/Global/context';
import { logout } from '../../../utils';

import * as S from './styles';

export const SelecaoGrupoContrato = ({
    alreadySearched = true,
    loadingContracts,
    rowsPerPage = 8,
    setAuthorizationState,
    setContractGroupSelected,
    setSuportFlow,
    suportDocument = {},
}) => {
    const [pagination, setPagination] = useState({ activePage: 0, showingData: [] });
    const [filtered, setFiltered] = useState([]);
    const [qtdPages, setQtdPages] = useState(1);

    const PAGES = Array.from(Array(qtdPages).keys());

    const { contractsGroupsList, contrastTheme } = useGlobal();

    function handleChangePage(activePage) {
        if (activePage >= 0 && activePage < qtdPages) {
            setPagination({
                activePage,
                showingData: [...filtered].splice(activePage * rowsPerPage, rowsPerPage),
            });
        }
    }

    async function handleSearch(value) {
        const filteredValues = contractsGroupsList.filter((group) => {
            const includesIdGroup = group.idGrupoContrato?.toString()?.includes(value?.toString());
            const includesGroup = group.grupoContrato?.toLowerCase()?.includes(value?.toLowerCase());

            const hasSomeChild = group.contratos.find(
                ({ numeroContrato, nomeContrato }) =>
                    numeroContrato?.includes(value?.toString()) ||
                    nomeContrato?.toLowerCase()?.includes(value?.toString())
            );

            return includesIdGroup || includesGroup || !value || hasSomeChild;
        });

        setQtdPages(Math.ceil(filteredValues.length / rowsPerPage));

        setPagination({
            activePage: 0,
            showingData: [...filteredValues].splice(0 * rowsPerPage, rowsPerPage),
        });

        setFiltered(filteredValues);
    }

    function handleSelect(value) {
        setContractGroupSelected({
            contractGroupNumber: value,
        });

        setAuthorizationState({
            grupoContratoSelecionado: true,
            contratoSelecionado: true,
            autenticado: false,
        });

        setSuportFlow({ step: 2 });
    }

    useEffect(() => {
        setFiltered(contractsGroupsList);

        setPagination({
            activePage: 0,
            showingData: [...contractsGroupsList].splice(0, rowsPerPage),
        });

        setQtdPages(Math.ceil(contractsGroupsList.length / rowsPerPage));
    }, [contractsGroupsList]);

    return (
        <S.ContainerCard>
            <Accordion title="Escolha o grupo de contrato" hasCollapse={false}>
                {!contractsGroupsList.length && !loadingContracts && (
                    <S.AlertContainer>
                        <Alert
                            type={2}
                            title={`Não encontramos nenhum contrato associado ao seu ${suportDocument.field}.`}
                            message="Por favor, entre em contato com o GNDI ou realize novamente o seu primeiro acesso."
                        />

                        <Button type="secondary" onClick={() => logout()}>
                            Voltar
                        </Button>
                    </S.AlertContainer>
                )}

                {!!contractsGroupsList.length && (
                    <>
                        {contractsGroupsList.length > rowsPerPage && (
                            <SearchContainer
                                field={{
                                    id: 'searchField',
                                    label: 'Nº do grupo',
                                    required: true,
                                }}
                                onSearch={handleSearch}
                            />
                        )}

                        <SelectGroup>
                            {pagination.showingData.map(({ idGrupoContrato, grupoContrato, contratos }, index) => (
                                <Select key={`${idGrupoContrato}-${index}`}>
                                    <S.StyledLink
                                        id={idGrupoContrato}
                                        to="/selecao_contrato"
                                        onClick={() => handleSelect(idGrupoContrato)}
                                    >
                                        <S.InfosContainer>
                                            <S.ContractNumber>{idGrupoContrato}</S.ContractNumber>
                                            <S.ContractName title={grupoContrato}>{grupoContrato}</S.ContractName>
                                        </S.InfosContainer>
                                        <S.Right>
                                            <Icon
                                                style={{ paddingTop: '10px' }}
                                                name="ArrowRight"
                                                color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                                            />
                                            <S.ContractsQuantity>
                                                {contratos.length}
                                                {contratos.length > 1 ? ' contratos' : ' contrato'}
                                            </S.ContractsQuantity>
                                        </S.Right>
                                    </S.StyledLink>
                                </Select>
                            ))}
                        </SelectGroup>

                        {!loadingContracts && alreadySearched && PAGES.length > 1 && (
                            <Pagination
                                type="simple"
                                loading={loadingContracts}
                                alreadySearched={alreadySearched}
                                pagination={pagination}
                                pages={PAGES}
                                handleChangePage={handleChangePage}
                            />
                        )}
                    </>
                )}
            </Accordion>
        </S.ContainerCard>
    );
};
